import { AdminShell, MimaTable, MimaText } from '../../../components';
import { useAdminOrdersLogic } from './logic';
import styles from '../../../assets/styles/Admin/AdminOrders.module.scss';
import { MetricGroup } from '../../../components';
import { AnimatePresence } from 'framer-motion';
import AdminOrderDetailModal from './AdminOrderDetailModal';
import AdminUpdateOrderModal from './AdminUpdateOrderModal';

export const AdminOrders = () => {
	const {
		tableData,
		tableColumns,
		totalCounts,
		setSearchQuery,
		isFetching,
		onLimitChange,
		limit,
		currentPage,
		setCurrentPage,
		isLoading,
		orderAnalysis,
		openModal,
		modalConstants,
		closeModal,
	} = useAdminOrdersLogic();

	return (
		<AdminShell pageTitle={'Orders'} childClassName={styles.orders}>
			<div className={styles.orders__top}>
				<MimaText variant="subtitleBold">Orders Analysis</MimaText>
				<div>Filter</div>
			</div>

			<MetricGroup metrics={orderAnalysis} />
			<MimaTable
				tableData={tableData}
				tableColumns={tableColumns}
				searchPlaceholder="Search Orders"
				searchVariant="wide"
				totalItems={totalCounts}
				onLimitChange={onLimitChange}
				isLoading={isLoading}
				isFetching={isFetching}
				limit={limit}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
			/>
			{openModal !== '' && (
				<div className="modal">
					<AnimatePresence>
						{openModal === modalConstants.view && (
							<AdminOrderDetailModal closeModal={closeModal} />
						)}
						{openModal === modalConstants.update && (
							<AdminUpdateOrderModal closeModal={closeModal} />
						)}
					</AnimatePresence>
				</div>
			)}
		</AdminShell>
	);
};

export default AdminOrders;
